var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 74,
    viewBox: "0 0 112 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 74,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SailGP",
    clipPath: "url(#clip0_29735_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 1272,
    transform: "translate(-139 -112)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 3136",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: -123,
    y: -40,
    width: 358,
    height: 466,
    rx: 6,
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UCL_MCcomposite_OS_HZ_RGB-REV-mastercard_symbol-eng 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70.2691 7.85693H40.3545V63.9432H70.2691V7.85693Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.2557 35.9001C42.2557 24.5259 47.3641 14.3848 55.316 7.85693C49.4967 3.07959 42.1648 0.233887 34.1881 0.233887C15.3086 0.233887 0 16.2043 0 35.9001C0 55.5958 15.3086 71.5663 34.1881 71.5663C42.1648 71.5663 49.505 68.7206 55.316 63.9432C47.3641 57.4153 42.2557 47.2829 42.2557 35.9001Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M110.632 35.9001C110.632 55.5958 95.3234 71.5663 76.4439 71.5663C68.4672 71.5663 61.127 68.7206 55.316 63.9432C63.2679 57.4153 68.3763 47.2829 68.3763 35.9001C68.3763 24.5172 63.2679 14.3848 55.316 7.85693C61.1353 3.07959 68.4672 0.233887 76.4439 0.233887C95.3234 0.233887 110.632 16.2043 110.632 35.9001Z",
    fill: "#F79E1B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29735_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 1272,
    fill: "white",
    transform: "translate(-139 -112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.64563abfddfb37a1937ff6fd65bc0d06.svg";
export { ForwardRef as ReactComponent };